module.exports = __webpack_public_path__ + "img/thumb_37.6accb8e9.jpg";